import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
export const FullscreenInfo = (props) => {
    const [t, i18n] = useTranslation();
    return (React.createElement(Dialog, { open: true, onClose: props.onClose },
        React.createElement(DialogTitle, { id: "fullscreen-dialog-title" },
            React.createElement(Typography, { variant: "h4" }, t("common:fullscreen dialog title"))),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "fullscreen-dialog-description" },
                React.createElement(Typography, { variant: "body1" }, t("common:fullscreen dialog content")))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => props.onClose, color: "primary", autoFocus: true }, t("common:action close")))));
};
